export default __webpack_public_path__ + "static/media/damaged-icon.50a31405.svg";